const SearchActionTypes = {
  SET_INPUT_SEARCH: "SEARCH_SET_INPUT_SEARCH",
  RESET_SEARCH_INPUT_VALUE: "SEARCH_RESET_SEARCH_INPUT_VALUE",
};

export default SearchActionTypes;
